import { BaseInputFilter } from "domain/models/base-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { IClientRepository } from "domain/contracts/client.contract";
import { Client } from "domain/entities/client";

class ClientRepository implements IClientRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/client/${id}`);
    return response.data;
  }

  async create(input: Client): Promise<Message<Client>> {
    const response = await httpClient.post(`/client`, { data: input });
    return response.data;
  }

  async update(input: Client): Promise<Message<boolean>> {
    const response = await httpClient.put(`/client/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: BaseInputFilter): Promise<Message<Client[]>> {
    const response = await httpClient.get(`/client`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Client>> {
    const response = await httpClient.get(`/client/${id}`);
    return response.data;
  }
}

export default new ClientRepository();
